import _isEqual from 'lodash/isEqual';
import { helper } from '@ember/component/helper';

function isEqFn([left, right]: any[] /*, hash*/) {
  return _isEqual(left, right);
}
export default helper(isEqFn);
